/* ============================================================
   Valyriano — Toggle de densidad 2 / 4 columnas (delta 5)
   No invasivo: inserta 2 botones en la barra de la colección y
   alterna .vly-density-2 / .vly-density-4 sobre .product-grid.
   Recuerda la preferencia en localStorage ('vly_density').
   Robusto: si no encuentra grid o toolbar, no hace nada.
   ============================================================ */
(function () {
  var KEY = 'vly_density';
  var GRID_TWO = 'vly-density-2';
  var GRID_FOUR = 'vly-density-4';

  var ICON_2 =
    '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><rect x="1" y="1" width="8" height="18"/><rect x="11" y="1" width="8" height="18"/></svg>';
  var ICON_4 =
    '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><rect x="1" y="1" width="3.5" height="18"/><rect x="6.2" y="1" width="3.5" height="18"/><rect x="11.3" y="1" width="3.5" height="18"/><rect x="16.5" y="1" width="3.5" height="18"/></svg>';

  function readPref() {
    try {
      return localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }
  function writePref(v) {
    try {
      localStorage.setItem(KEY, v);
    } catch (e) {
      /* localStorage no disponible: se ignora, el toggle sigue funcionando en memoria */
    }
  }

  function getGrid() {
    // El grid principal de la colección tiene id="product-grid".
    return document.getElementById('product-grid');
  }

  function applyDensity(grid, density) {
    if (!grid) return;
    grid.classList.remove(GRID_TWO, GRID_FOUR);
    if (density === '2') grid.classList.add(GRID_TWO);
    else if (density === '4') grid.classList.add(GRID_FOUR);
  }

  function updateButtons(toolbar, density) {
    var btns = toolbar.querySelectorAll('.vly-density-toolbar__btn');
    btns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-density') === density ? 'true' : 'false');
    });
  }

  function buildToolbar(grid) {
    var toolbar = document.createElement('div');
    toolbar.className = 'vly-density-toolbar';
    toolbar.setAttribute('role', 'group');
    toolbar.setAttribute('aria-label', 'Densidad de la cuadrícula');

    [['2', ICON_2, 'Ver 2 columnas'], ['4', ICON_4, 'Ver 4 columnas']].forEach(function (cfg) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vly-density-toolbar__btn';
      btn.setAttribute('data-density', cfg[0]);
      btn.setAttribute('aria-label', cfg[2]);
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = cfg[1];
      btn.addEventListener('click', function () {
        var current = getGrid(); // re-leer: Dawn reemplaza el grid al filtrar
        applyDensity(current, cfg[0]);
        updateButtons(toolbar, cfg[0]);
        writePref(cfg[0]);
      });
      toolbar.appendChild(btn);
    });

    return toolbar;
  }

  function init() {
    var grid = getGrid();
    if (!grid) return; // no estamos en una colección con productos

    // Evita duplicar si ya se insertó (p.ej. re-init tras filtrado)
    if (document.querySelector('.vly-density-toolbar')) {
      var pref0 = readPref() || '4';
      applyDensity(grid, pref0);
      return;
    }

    var toolbar = buildToolbar(grid);

    // Punto de inserción preferido: la barra de orden vertical de Dawn.
    var sortBar = document.querySelector('.facets-vertical-sort .facet-filters.sorting');
    if (sortBar && sortBar.parentNode) {
      sortBar.parentNode.insertBefore(toolbar, sortBar);
    } else {
      // Fallback: justo antes del contenedor del grid.
      var container = document.getElementById('ProductGridContainer') || grid;
      container.parentNode.insertBefore(toolbar, container);
    }

    var pref = readPref() || '4';
    applyDensity(grid, pref);
    updateButtons(toolbar, pref);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn reemplaza el grid al aplicar filtros/orden: re-aplica la densidad guardada.
  document.addEventListener('shopify:section:load', init);
  // Observa cambios del contenedor del grid para re-aplicar la clase tras filtrado AJAX.
  var host = document.getElementById('ProductGridContainer');
  if (host && window.MutationObserver) {
    var mo = new MutationObserver(function () {
      var grid = getGrid();
      if (grid && !grid.classList.contains(GRID_TWO) && !grid.classList.contains(GRID_FOUR)) {
        applyDensity(grid, readPref() || '4');
      }
    });
    mo.observe(host, { childList: true, subtree: true });
  }
})();
